<script>
import {mapGetters} from 'vuex'
import Settings from '../../../mixins/edit/Settings';
export default {
    name: 'create-offer-settings',
    mixins: [Settings],
    data()
    {
        return {
            action:
            {
                update: 'offerUpdate',
            },
            subPageName: 'offers-subpages',
            id: 'offer_id',
        }
    },
}
</script>

<template lang="html">
    <div >
        <div class="py-5 border-sides-1-secondary border-bottom-1-secondary" >
            <div class="px-3">
                <div class="row mb-3">
                    <div class="col-2 text-right pt-2 font-weight-bold">
                        Hosted URL
                    </div>
                    <div class="col-10">
                        <simple-input
                        type="text"
                        :preText="startUrl"
                        v-model="item.url"
                        placeholder="Add hosted url"
                        noRadius
                        ></simple-input>
                    </div>
                </div>
            </div>
            <div class="px-3 border-top-1-secondary pt-4">
                <div class="row mb-3">
                    <div class="col-2 text-right pt-2 font-weight-bold">
                        Offer price
                    </div>
                    <div class="col-2">
                        <simple-input
                        preText="$"
                        type="number"
                        isMoney
                        min=0
                        v-model="item.price"
                        noRadius
                        ></simple-input>
                    </div>
                </div>
            </div>
            <div class="px-3 border-top-1-secondary pt-4">
                <div class="row mb-3">
                    <div class="col-2 text-right pt-2 font-weight-bold">
                        Expires at
                    </div>
                    <div class="col-3">
                        <date-input v-model="item.expires_at" noRadius icon="fal fa-calendar"></date-input>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-2 text-right pt-2 font-weight-bold">
                        Schedule from
                    </div>

                    <div class="col-3">
                        <date-input v-model="item.scheduled_from" noRadius icon="fal fa-calendar"></date-input>
                    </div>
                    <div class="col-1 pt-2 font-weight-bold">
                        to
                    </div>
                    <div class="col-3">
                        <date-input v-model="item.scheduled_to" noRadius icon="fal fa-calendar"></date-input>
                    </div>
                </div>
            </div>
            <div class="px-3 border-top-1-secondary pt-4">
                <div class="row mb-3">
                    <div class="col-2 text-right font-weight-bold">
                        Wedding date
                    </div>
                    <div class="col-3 pt-1">
                        <switcher
                        class="d-inline-block mr-2"
                        v-model="item.has_wedding_date"
                        ></switcher>
                        <span class="text-blue text-sm va-super " v-if="item.has_wedding_date">Displayed</span>
                        <span class="text-orange text-sm va-super " v-else>Hidden</span>
                    </div>
                </div>
            </div>
            <div class="px-3 border-top-1-secondary pt-4">
                <div class="row mb-3">
                    <div class="col-2 text-right font-weight-bold">
                        Host N Post
                    </div>
                    <div class="col-3 pt-1">
                        <switcher
                        class="d-inline-block mr-2"
                        v-model="item.is_hostnpost"
                        ></switcher>
                        <span class="text-blue text-sm va-super " v-if="item.is_hostnpost">Enabled</span>
                        <span class="text-orange text-sm va-super " v-else>Disabled</span>
                    </div>
                </div>
                <div v-if="item.is_hostnpost" class="row">
                    <div class="col-2"></div>
                    <div class="col-9">
                        <div class="border border-radius-4-top">
                            <table class="create-offer-fields">
                                <thead>
                                    <tr class="border-radius-4-top">
                                        <th colspan="2">
                                            Select data fields to collect
                                        </th>
                                    </tr>
                                </thead>
                                <tbody v-if="fields">
                                    <tr v-for="(field, index) in fields" :class="{'grey-bg': !item.name}">
                                        <td style="width:10%" class="text-center">
                                            <switcher
                                                class="d-inline-block mr-2"
                                                @input="setField($event, field)"
                                                :value="item.fields.getBy('id', field.id).id"
                                            ></switcher>
                                        </td>
                                        <td style="width:90%">
                                            <strong>{{ field.label }} ({{ field.name }})</strong> <br>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div v-else class="row">
                    <div class="col-2 text-right font-weight-bold">
                        Referral link
                    </div>
                    <div class="col-10">
                        <simple-input
                        type="text"
                        v-model="item.referal_url"
                        placeholder="Referral link"
                        noRadius
                        ></simple-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="grey-bg border-bottom-1-secondary border-sides-1-secondary px-3 py-2">
            <div class="row">
                <div class="col-3">
                    <custom-button v-if="false" classes="white text-desc-color xs" iconBeforeText="fas fa-eye mr-2" text="Preview" @buttonClick="preview" ></custom-button>
                </div>
                <div class="col-9 text-right">
                    <custom-button classes="white text-desc-color w-120" text="Discard" @buttonClick="discard"></custom-button>
                    <custom-button classes="blue text-white w-120" text="Save" @buttonClick="save"></custom-button>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/pages/offers/edit/Settings.vue